import { SEATING_PREFERENCE_OPTIONS } from './constants';
export const getSegment = function (segments, activeSegment) {
  if (segments === void 0) {
    segments = [];
  }
  const hasSegments = segments.some(_ref => {
    let {
      segmentIndex
    } = _ref;
    return Number.isInteger(segmentIndex);
  });
  if (!hasSegments) {
    return null;
  }
  return segments.find(_ref2 => {
    let {
      boundSegmentIndex
    } = _ref2;
    return boundSegmentIndex === activeSegment;
  });
};
const isSegmentAvailable = segment => {
  const isSeatPreferenceAvailable = segment.__typename && (segment.__typename === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE || segment.__typename === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_PREFERENCE);
  return Boolean(segment.mainDeck || segment.lowerDeck || segment.upperDeck || isSeatPreferenceAvailable);
};
export const flatBounds = function (bounds) {
  if (bounds === void 0) {
    bounds = [];
  }
  return bounds.flatMap(segments => segments.sellSeatMapSegments.map(segment => ({
    ...segment,
    boundIndex: segments.boundIndex,
    boundName: segments.boundName,
    boundSegmentId: [segments.boundIndex, segment.boundSegmentIndex],
    isAvailable: isSegmentAvailable(segment)
  })));
};
export const getNextSegment = function (segments, activeSegment) {
  if (activeSegment === void 0) {
    activeSegment = null;
  }
  if (!Array.isArray(segments) || segments.length === 0) {
    return null;
  }
  const activeIndex = segments.findIndex(segment => typeof segment.boundSegmentIndex === 'string' && segment.boundSegmentIndex === activeSegment);
  const nextSegment = segments.find((_, index) => index > activeIndex);
  return nextSegment || null;
};
export const findIndexOfSegment = (segments, boundSegmentIndex) => segments.findIndex(b => b.boundSegmentIndex === boundSegmentIndex);
export const findNextAvailableSegment = function (segments, activeSegmentIndex) {
  if (segments === void 0) {
    segments = [];
  }
  const activeIndex = findIndexOfSegment(segments, activeSegmentIndex);
  const succeedingSegments = segments.slice(activeIndex + 1);
  const [nextSegment] = succeedingSegments;
  return nextSegment;
};
export const isLastAvailableSegment = (segments, boundSegmentIndex) => {
  const last = segments[segments.length - 1];
  return last.boundSegmentIndex === boundSegmentIndex;
};
//# sourceMappingURL=seatMapContentUtils.js.map